module.exports = __webpack_public_path__ + "static/2-f3bc504fed131fedc90ee31c59221db9.jpg";